var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 100,
    y2: 0,
    stroke: "rgba(255,255,255,0.1)",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 20,
    x2: 100,
    y2: 20,
    stroke: "rgba(255,255,255,0.1)",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 40,
    x2: 100,
    y2: 40,
    stroke: "rgba(255,255,255,0.1)",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 60,
    x2: 100,
    y2: 60,
    stroke: "rgba(255,255,255,0.1)",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 80,
    x2: 100,
    y2: 80,
    stroke: "rgba(255,255,255,0.1)",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 100,
    x2: 100,
    y2: 100,
    stroke: "rgba(255,255,255,0.1)",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 100,
    stroke: "rgba(255,255,255,0.1)",
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 100,
    stroke: "rgba(255,255,255,0.1)",
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 100,
    stroke: "rgba(255,255,255,0.1)",
    strokeWidth: 0.5
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 100,
    stroke: "rgba(255,255,255,0.1)",
    strokeWidth: 0.5
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 0,
    x2: 80,
    y2: 100,
    stroke: "rgba(255,255,255,0.1)",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 100,
    stroke: "rgba(255,255,255,0.1)",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.8969ab375192b498c282e9e784ab2c56.svg";
export { ForwardRef as ReactComponent };